import i18n from '@plugins/localisation.js'
import { computed, unref } from 'vue'

export function getTagOptions(filterRef) {
  return computed(() => {
    const filter = unref(filterRef)
    if (filter.keys)
      return filter.keys.map((f, i) => ({ name: filter.tags[i], key: f }))

    const tagKey = filter.showMore ? 'allTags' : 'tags'

    if (!filter[tagKey]) return []

    return filter[tagKey].map((t) => {
      const localized = filter.tags_localization?.find((l) => t === l.tag)
        ?.translations[i18n.global.locale.value]
      return {
        name: t,
        localized,
      }
    })
  })
}

export function getTagOptionName(filter) {
  const localized = filter.name_localization?.[i18n.global.locale.value]
  return (
    localized ||
    (filter.name_key ? i18n.global.t(filter.name_key) : filter.name)
  )
}

export function getTags(_tagOptions, isGameModerator, resourceRef) {
  const tagOptions = unref(isGameModerator)
    ? _tagOptions
    : _tagOptions.filter((tagGroup) => !tagGroup.hidden)

  const tagPropertyName = resourceRef.value?.collection_tags
    ? 'collection_tags'
    : 'tags'

  return resourceRef.value[tagPropertyName]
    .filter((tag) => tagOptions.find((o) => o.tags.includes(tag.name)))
    .map((tag) => {
      const option = tagOptions.find((o) => o.tags.includes(tag.name))
      return {
        name: tag.name,
        localized: option.tags_localization?.find((l) => l.tag === tag.name)
          .translations[i18n.global.locale.value],
      }
    })
}
